import Store from '@/store'

export default {
    async init(options = {}) {

    },

    isEnabled() {
        return locale === 'sr' && !!Store.getters.tenant?.venue?.settings?.einvoice?.api_key;
    },

    isAllowed() {
        const venue = Store.getters.tenant?.venue;
        if(!venue || locale !== 'sr') return false;

        const modules = Store.getters.modules
        if(!modules?.einvoices) return false

        return venue.tax_id_number
            && venue.registration_number
            && venue.city
            && venue.postal_number
            && venue.country
            && venue.bank_account_number;
    },

    einvoiceOnly() {
        return locale === 'sr' && !!Store.getters.tenant?.venue?.settings?.noncash_only;
    },
}
